import { TextFieldProps } from "@material-ui/core";
import { useFormContext } from "components/Form";
import { Input as InputComponent } from "components/Input";
import { useCallback } from "react";
import { Controller } from "react-hook-form";
// @ts-ignore
import { mask, unMask } from "remask";

type InputMaskProps = TextFieldProps & {
  name: string;
  masks: string[];
  customLabel?: string;
};

export function InputMask({ masks, customLabel, ...props }: InputMaskProps) {
  const {
    methodsForm: { control },
  } = useFormContext();

  const handleOnChange = useCallback(
    (value: string) => {
      const originalValue = unMask(value);
      const maskedValue = mask(originalValue, masks);

      return maskedValue;
    },
    [masks]
  );

  return (
    <Controller
      name={props.name}
      control={control}
      defaultValue=""
      render={({ field }) => {
        const { ref, value, onChange, ...fieldProps } = field;
        return (
          <InputComponent
            {...props}
            {...fieldProps}
            customLabel={customLabel}
            value={value || ""}
            onChange={(event) =>
              onChange(handleOnChange(event.target.value))
            }
            ref={ref}
          />
        );
      }}
    />
  );
}
